import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
  border-left:4px solid ${p => p.$color || p.theme.colors.primary};
  background:${p => (p.$color || p.theme.colors.primary) + '12'};
  border-radius:${p => p.theme.radius.md}px;
  padding:${p => p.theme.spacing[4]}px;
  border:1px solid ${p => p.theme.colors.border};
  box-shadow:${p => p.theme.shadow.card};
`;
const CardLabel = styled.div`
  font-size:${p => p.theme.typography.sizes.xs};
  color:${p => p.theme.colors.text.secondary};
  font-weight:${p => p.theme.typography.weights.medium};
`;
const CardValue = styled.div`
  font-size:${p => p.theme.typography.sizes.xl};
  font-weight:${p => p.theme.typography.weights.bold};
  color:${p => p.theme.colors.text.primary};
  margin:4px 0;
`;
const CardSub = styled.div`
  font-size:${p => p.theme.typography.sizes.xs};
  color:${p => p.theme.colors.text.muted};
`;

export default function ScoreCard({ label, value, sublabel, color, icon }) {
  return (
    <Card $color={color}>
      <CardLabel>{icon} {label}</CardLabel>
      <CardValue>{value}</CardValue>
      {sublabel && <CardSub>{sublabel}</CardSub>}
    </Card>
  );
}
